import { configure } from 'utils/configure';

export interface CookieOptions {
  maxAge?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
}

export const getCookieOptions = ({ maxAge, path, domain, secure, sameSite }: CookieOptions): CookieOptions => ({
  secure: secure ?? true,
  sameSite: sameSite ?? 'lax',
  path: path ?? '/',
  maxAge,
  domain: domain ?? `.${configure.rootDomain}`,
});

export function getCookie<T = string>(name: string): T | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const nameEQ = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length)) as T;
    }
  }

  return undefined;
}

export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  if (typeof window === 'undefined') {
    return;
  }

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  if (options.maxAge) {
    const date = new Date();
    date.setTime(date.getTime() + options.maxAge);
    cookieString += `; expires=${date.toUTCString()}`;
  }
  if (options.path) {
    cookieString += `; path=${options.path}`;
  }
  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }
  if (options.secure) {
    cookieString += '; secure';
  }
  if (options.sameSite) {
    cookieString += `; samesite=${options.sameSite}`;
  }

  document.cookie = cookieString;
}
